import React, { useEffect, useState } from 'react';
import ChatscreenFractal from './ChatscreenFractal';
import {
	loadStateSession,
	saveStateSession,
} from '../../../FlyfishComponents/flyfishutils/utils';
import TokenExpiryHandler from '../TokenExpiryHandler';
import Axios from 'axios';
import { encryptText } from '../../../../../index';

export default function FractalTheme(props) {
	const [botLoaderMessage, setBotLoaderMessage] = useState('');

	useEffect(() => {}, []);
	const getAIConfiguration = async (value?) => {
		setBotLoaderMessage('Getting things ready for you!!');
		try {
			const response = await Axios.get(
				window['BASE_URL'] +
					`/configuration/${loadStateSession(
						'tenantId'
					)}/bot/${loadStateSession('botId')}`,
				{
					headers: {
						'x-tenant-id': loadStateSession('tenantId'),
						Authorization: `Bearer ${loadStateSession('token')}`,
					},
				}
			);

			if (response.data) {
				let botConfig = response.data.data.botConfig;
				let r = document.querySelector(':root');

				if (botConfig.length > 0) {
					for (let config of botConfig) {
						if (config.configName === 'message_api_url') {
							saveStateSession('message_api_url', config.value);
						}
						if (config.configName === 'selectedTheme') {
							saveStateSession('selectedTheme', config.value);
						}
						if (config.configName === 'searchBoxPlaceholder') {
							saveStateSession('searchBoxPlaceholder', config.value);
						}
						if (config.configName === 'colorMode') {
							saveStateSession('colorMode', config.value);
						}
						if (config.configName === 'fontSize') {
							//@ts-ignore
							r.style.setProperty('--fontSize', config.value);
						}
						if (config.configName === 'fontFamily') {
							const linkElement = document.createElement('link');
							linkElement.rel = 'stylesheet';
							linkElement.href = `https://fonts.googleapis.com/css2?family=${config.value}:wght@100;200;300;400;500;600;700;800&display=block`;
							document.head.appendChild(linkElement);
							//@ts-ignore
							r.style.setProperty('--fontFamily', config.value);
						}
					}
				}

				setBotLoaderMessage('');
			}
		} catch (error) {
			setBotLoaderMessage(
				error.response.data.message ||
					'Fetching Bot config failed. Please refresh the page and try again.'
			);
		}
	};
	const anonymousLogin = async () => {
		setBotLoaderMessage('Logging you In');
		var date = new Date();
		var timestamp = Math.floor(date.getTime() / 1000.0);
		var usertenantID = encryptText(
			`${loadStateSession('tenantId')}:${timestamp}`
		);
		try {
			const response = await Axios.post(
				`${window['BASE_URL']}/authentication/anonynousLogin`,
				{
					name: 'anonymous',
					email: 'anonymousEmail',
					teamId: usertenantID,
				},
				{
					headers: {
						'x-tenant-id': loadStateSession('tenantId'),
						// Authorization: `Bearer ${loadStateSession('token')}`,
					},
				}
			);

			if (response.data) {
				let token = response.data.data.token;
				saveStateSession('token', token);
				saveStateSession('botLoggedIn', true);
				setBotLoaderMessage('');
				getAIConfiguration();
				saveStateSession('tokenExpiry', response.data.data.tokenExpiry);
			}
		} catch (error) {
			saveStateSession('botLoggedIn', false);
			setBotLoaderMessage(
				error.response.data.message ||
					'Bot login failed. Please refresh the page and try again.'
			);
		}
	};

	return (
		<div>
			{loadStateSession('tokenExpiry') && (
				<TokenExpiryHandler
					recallApi={anonymousLogin}
					tokenExpiry={loadStateSession('tokenExpiry')}
				/>
			)}
			{loadStateSession('botLoggedIn') ? (
				<ChatscreenFractal conversationOpener={props.data.botWelcomeMessage} />
			) : null}
		</div>
	);
}
